import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Navbar          from './components/Navbar';
import Footer          from './components/Footer';
import CustomCursor    from './components/CustomCursor';
import WhatsAppFloat   from './components/WhatsAppFloat';
import HomePage        from './pages/HomePage';
import ServicesPage    from './pages/ServicesPage';
import ProjectsPage    from './pages/ProjectsPage';
import AppsPage        from './pages/AppsPage';
import CoursesPage     from './pages/CoursesPage';
import TeamPage        from './pages/TeamPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactPage     from './pages/ContactPage';
// import CertificatePage from './pages/CertificatePage';  // ← NEW

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }); }, [pathname]);
  return null;
}

function AppInner() {
  return (
    <div className="min-h-screen flex flex-col bg-dark">
      <CustomCursor />
      <Navbar />
      <ScrollToTop />
      <main className="flex-1 mt-[68px]">
        <Routes>
          <Route path="/"             element={<HomePage />} />
          <Route path="/services"     element={<ServicesPage />} />
          <Route path="/projects"     element={<ProjectsPage />} />
          <Route path="/apps"         element={<AppsPage />} />
          <Route path="/courses"      element={<CoursesPage />} />
          <Route path="/team"         element={<TeamPage />} />
          <Route path="/testimonials" element={<TestimonialsPage />} />
          <Route path="/contact"      element={<ContactPage />} />
          {/* <Route path="/certificate"  element={<CertificatePage />} /> */}
        </Routes>
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

export default function App() {
  return <Router><AppInner /></Router>;
}
